import { useEffect, useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Videos() {
    const [videoUrls, setVideoUrls] = useState([]);

    useEffect(() => {
        fetch("/doc/youtube.txt")
            .then(response => response.text())
            .then(data => {
                // Split file content by new lines and trim each line
                const urls = data.split("\n").map(url => url.trim()).filter(Boolean);
                setVideoUrls(urls);
            })
            .catch(error => {
                console.error("Error loading YouTube URLs:", error);
            });
    }, []);

    return (
        <>
            <Header />
            <main>
                <section className="pad breadcrumbs top-cover">
                    <div id="breadcrumb" className="content">
                        <a href="Home">Home</a><i></i>
                        <span>Videos Series</span>
                    </div>
                </section>
                <section className="web3bank">
                    <div className="video-ser">
                        <div className="banner">
                        <img src="images/nugenesisou/channels4_banner.jpg" alt="" />
                        </div>

                        <div className="video-grid">
                            {videoUrls.map((url, index) => (
                                <div key={index} className="video-card enable-iframe">
                                    <iframe
                                        width="400"
                                        height="315"
                                        src={url}
                                        title={`YouTube video ${index + 1}`}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
